import { delay, NAVIGATION_SETTLE_MS } from '../domLocator'
import { ClientTool, studentPageRequested } from '../Tool'

interface Input extends Record<string, unknown> {
  appUserId: number
}

const navigateToNewPlan: ClientTool = {
  name: 'navigate_to_new_plan',
  category: 'navigate',
  execute: async (rawInput, ctx) => {
    const { appUserId } = rawInput as Input
    ctx.navigate(`/students/${appUserId}/plans/new`)
    await delay(NAVIGATION_SETTLE_MS)
    return studentPageRequested(ctx.getPathname())
  },
  getStepLabel: () => 'Navigating to new plan page…'
}

export default navigateToNewPlan
